import React from 'react';
import { useQuery } from 'react-query';

import { useQuizContext } from '../../../context/QuizContext';
import Modal from '../../Modal';
import { useFetch } from '../../../context/FetchProvider';
import { LoadingSpinner } from '@osmosis/react-ui/components/LoadingSpinner';
import { fetchRepetitionSettings } from './api';
import { RepetitionSettingsForm } from './RepetitionSettingsForm';

/**
 * RepetitionSettingsModal.
 */
const RepetitionSettingsModal = () => {
  const { showRepetitionSettings, setShowRepetitionSettings } =
    useQuizContext();
  const { get } = useFetch();

  const { data, isLoading, refetch } = useQuery(
    'settingsModal',
    () => fetchRepetitionSettings(get),
    {
      refetchOnWindowFocus: false,
    },
  );

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      {data && (
        <Modal
          _className="overflow-hidden h-full"
          className="max-w-[480px] h-full"
          hide={() => setShowRepetitionSettings(false)}
          isVisible={showRepetitionSettings}
        >
          <RepetitionSettingsForm refetch={refetch} initialData={data} />
        </Modal>
      )}
    </>
  );
};

export default RepetitionSettingsModal;
